import SideNav from "../components/side-nav/SideNav";
import {
    expandMobileSideNav,
    collapseMobileSideNav
} from "../ducks/sideNav";
import { connect } from "react-redux";
import User from "../services/User";

export function mapStateToProps(state, ownProps) {
    return {
        mobileSideNavExpanded: state.sideNav.mobileSideNavExpanded,
        location: ownProps.location
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        expandMobileSideNav() {
            dispatch(expandMobileSideNav());
        },
        collapseMobileSideNav() {
            dispatch(collapseMobileSideNav());
        },
        logout(redirectURL) {
            return User.logout(redirectURL);
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SideNav);
